export default __webpack_public_path__ + "static/media/Frame 407.bec26e21.png";